import React from 'react';
import Icon from '../../../icon';
import Flag from '../../../flag';
const defaultIcon = {};
const defaultFormatLabel = (label) => label;

const BaseOption = ({
  value,
  label,
  icon = defaultIcon,
  flag,
  note = '',
  formatLabel = defaultFormatLabel,
}) => (
  <div className="ws-ui-base-select-option" key={value}>
    {!!icon.glyph && (
      <div className="ws-ui-base-select-option__icon">
        <Icon {...icon} />
      </div>
    )}
    {!!flag?.code && !icon.glyph && (
      <div className="ws-ui-base-select-option__flag">
        <Flag code={flag.code} />
      </div>
    )}
    <div className="ws-ui-base-select-option__label">{formatLabel(label)}</div>
    {!!note && <div className="ws-ui-base-select-option__note">{note}</div>}
  </div>
);

export default BaseOption;
